"use strict";
/*
 * Created on 09 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link SiteReleaseUpload}.</p>
 *
 * @author Jaroslav Sevcik
 */


var SiteReleaseUploadConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SiteReleaseUploadConverter, _DataObjectConverter_);

  function SiteReleaseUploadConverter() {
    _classCallCheck(this, SiteReleaseUploadConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseUploadConverter).apply(this, arguments));
  }

  return SiteReleaseUploadConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SiteReleaseUploadConverter = SiteReleaseUploadConverter;